import type { ExperimentsContext } from '@adv-frontend/yastore-modules/lib';

export function getMonitoringExperiments({ experimentsFlags = {}, experimentsBoxes }: ExperimentsContext) {
    return {
        experiments: Object.entries(experimentsFlags).flatMap(([name, value]) =>
            value === undefined ? [] : `${name}=${value}`
        ),
        slots: experimentsBoxes ?? [],
    };
}
